import * as EBML from 'ts-ebml';
import EventEmitter from 'events';

let electron;
try {
  // eslint-disable-next-line
  electron = eval("require('electron')");
} catch (e) {
  electron = null;
  console.log('Media is not in an electron evrironment');
}

class Media extends EventEmitter {
  constructor(options) {
    super(options);
    this.options = options;
  }

  static makeDownload(file, container) {
    const video = document.createElement('video');
    const url = URL.createObjectURL(file);
    video.src = url;
    video.controls = true;
    video.download = `${new Date().valueOf()}.mp4`;
    container.appendChild(video);
  }

  getSeekableBlob(inputBlob, callback) {
    const reader = new EBML.Reader();
    const decoder = new EBML.Decoder();
    const {
      tools,
    } = EBML;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const ebmlElms = decoder.decode(fileReader.result);
      ebmlElms.forEach((element) => {
        reader.read(element);
      });
      reader.stop();
      // console.log(reader.metadatas, 'reader11111');
      if (reader.metadatas.length > 0) {//先判断一下reader.metadatas的length,否则控制台会报dataEnd is undefined
        const refineMetadataBuf = tools.makeMetadataSeekable(reader.metadatas, reader.duration,
          reader.cues);
        const body = fileReader.result.slice(reader.metadataSize);
        const newBlob = new Blob([refineMetadataBuf, body], {
          type: 'video/mp4',
        });
        if (callback && typeof callback === 'function') {
          callback(newBlob);
        }
        this.emit('record-done', newBlob);
      }
    };
    fileReader.readAsArrayBuffer(inputBlob);
  }

  start() {
    try {
      if (this.options.video) {
        if (this.options.streamSource === 'screen') { // 用屏幕共享作为源
          if (!electron) {
            return navigator.mediaDevices.getDisplayMedia(this.options).then((stream) => {
              this.stream = stream;
              return stream;
            });
          }
          if (electron) { // electron 的接口不太一样
            return navigator.mediaDevices.getUserMedia(this.options).then((stream) => {
              this.stream = stream;
              return stream;
            });
          }
            throw Error('不支持屏幕共享');
        }
        if (this.options.streamSource === 'camera') {
          return navigator.mediaDevices.getUserMedia(this.options).then((stream) => {
            this.stream = stream;
            return stream;
          });
        }
      } else if (this.options.audio) {
        return navigator.mediaDevices.getUserMedia(this.options).then((stream) => {
          this.stream = stream;
          return stream;
        });
      }
      throw Error('video 和 audio 不能同时为false');
    } catch (err) {
      return Promise.reject(err);
    }
  }

  getDevices(kind) {
    try {
      return navigator.mediaDevices.enumerateDevices().then((devices) => {
        this.devices = devices;
        const filterd = devices.filter((item) => {
          if (!kind) {
            return true;
          }
          return item.kind === kind;
        });
        return filterd;
      }).catch((err) => {
        console.log(err);
      });
    } catch (err) {
      return Promise.reject(err);
    }
  }

  getAudioDevices() {
    return this.getDevices('audioinput');
  }

  getVideoDevices() {
    return this.getDevices('videoinput');
  }

  initRecorder(stopCb) {
    if (this.stream) {
      console.log('init recorder');
      let chunks = [];
      const downloadBox = this.options.downloadBox && document.querySelector(
        `#${this.options.downloadBox}`,
      );
      this.playVideo();
      this.recorder = new MediaRecorder(this.stream);
      this.recorder.onstop = (e) => {
        this.videoRecording = false; // 已经结束录制
        const dFile = new Blob(chunks, {
          type: 'video/mp4',
        });
        this.getSeekableBlob(dFile, stopCb);
        chunks = []; // 清空以准备下一次录制
        if (downloadBox) {
          Media.makeDownload(dFile, downloadBox);
        }
      };
      this.recorder.ondataavailable = (e) => {
        chunks.push(e.data);
      };
      this.emit('recorder-init-done');
      return this.recorder;
    }
    return null;
  }

  playVideo() {
    if (this.options.video) {
      this.previewBox = this.options.previewBox && document.querySelector(
        `#${this.options.previewBox}`,
      );

      if (this.previewBox) {
        const video = document.createElement('video');
        video.srcObject = this.stream;
        video.controls = false;
        video.muted = true;
        this.previewBox.appendChild(video);
        video.play();
        this.video = video;
      }
    } else {
      throw new Error('No video can be played');
    }
  }

  startRecord() {
    console.log('%c start record', 'color:red;');
    // console.log(this.recorder, 'caaaaaaaaaa');
    if (this.recorder.state !== 'recording') {
      this.recorder.start();
    }
    // this.recorder.start();
    this.videoRecording = true;
  }

  stopRecord() {
    console.log('%c stop record', 'color:red;');
    // this.recorder.stop();
    if (this.recorder.state !== 'inactive') {
      this.recorder.stop();
    }
  }

  captureImage(video, cb, container) {
    const tmpCanvas = document.createElement('canvas');
    const tracks = this.stream.getVideoTracks();
    const vt = tracks[0];
    const settings = vt.getSettings();
    const {
      aspectRatio,
    } = settings;
    const height = 480;
    tmpCanvas.width = parseInt(height * aspectRatio, 10)
      || height; // aspectRatio is not supported in firefox
    tmpCanvas.height = height;

    function drawVideo(context) {
      try {
        context.drawImage(video, 0, 0, tmpCanvas.width, tmpCanvas.height);
        tmpCanvas.toBlob((blob) => {
            if (cb && typeof cb === 'function') {
              cb(blob);
            }
          },
          'image/png');
      } catch (e) {
        console.log(e);
      }
    }
    const context = tmpCanvas.getContext('2d');
    drawVideo(context);
  }

  destroy() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    this.stream = null;
    if (this.previewBox) this.previewBox.innerHTML = '';
  }
}

export default Media;
